module.exports = __webpack_public_path__ + "img/coreintercomDesk.f0f8a30b.png";